import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {useState} from 'react';
import CadViewerDialog from '@/pages/Preview/CadViewerDialog';

type ViewOrDownloadButtonGroupProps = {
    fileType: 'DWG' | 'STEP';
    fileLink: string;
    /** Converted drawing behind the viewer. Null when conversion has not run or did not succeed. */
    viewerLink?: string | null;
};

const ViewOrDownloadButtonGroup = ({
    fileType,
    fileLink,
    viewerLink,
}: ViewOrDownloadButtonGroupProps): JSX.Element => {
    const [viewerOpen, setViewerOpen] = useState(false);

    // The saved filename is the object key's basename, which is the part number. It cannot be set
    // here: the CAD files come from a separate CloudFront domain, and browsers ignore a download
    // attribute across origins. The new tab contains a missing object, which the bucket answers
    // with a renderable 403 body that would otherwise replace the configurator and its selection.
    if (fileType === 'STEP' || !viewerLink) {
        return (
            <Button
                variant="contained"
                startIcon={<FileDownloadIcon />}
                component="a"
                href={fileLink}
                target="_blank"
            >
                Download {fileType}
            </Button>
        );
    }

    return (
        <>
            <ButtonGroup variant="contained">
                <Button onClick={() => setViewerOpen(true)}>View {fileType}</Button>
                <Button
                    component="a"
                    href={fileLink}
                    target="_blank"
                    aria-label={`Download ${fileType}`}
                >
                    <FileDownloadIcon />
                </Button>
            </ButtonGroup>
            <CadViewerDialog
                open={viewerOpen}
                onClose={() => setViewerOpen(false)}
                dxfUrl={viewerLink}
            />
        </>
    );
};

export default ViewOrDownloadButtonGroup;
